import vueRouter from "@/router";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Loading } from 'element-ui';
// 导入权限工具函数
import { getToken, removeToken } from './utils/auth';
import { clearBtnAuth, getBtnAuth } from './utils/btnAuth';
import { getTree } from './utils/menuAuth';

// 配置进度条
NProgress.configure({ color: '#67d391', showSpinner: false });

// 加载配置
const loadingOptions = {
  fullscreen: true,
  text: 'Loading...',
  target: '.main_box',
  background: '#fff'
};


let loadingInstance = null;

vueRouter.beforeEach(async (to, from, next) => {
  NProgress.start();
  // console.log(to,from);

  // 判断是否需要权限验证
  if (to.meta.requiresAuth) {
    try {
      // 1. 验证登录状态
      if (!getToken()) {
        throw new Error('未登录，跳转到登录页');
      }

      // 2. 执行系统初始化
      await store.dispatch('initSetting', from);


      // 3. 处理按钮权限
      let btnAuth = null;
      const btnAllAuth = getBtnAuth() || {};

      // 尝试从缓存获取当前页面权限
      if (btnAllAuth) {
        btnAuth = btnAllAuth[to.path] || null;
      }

      // 缓存中没有权限时重新获取
      // 该页面的权限标识是否是一次性
      if (!btnAuth || to.meta.isOnce) {
        // 需要权限验证的页面显示加载提示
        loadingInstance = Loading.service(loadingOptions);
        const menuList = getTree();
        if (!menuList) {
          throw new Error('菜单列表不存在');
        }

        const tree = JSON.parse(menuList);

        // 递归查找路由对应的权限标识
        const findUniqueCode = (items) => {
          for (const item of items) {
            if (item.url === to.path) {
              return item.uniqueCode;
            }
            if (item.childList && item.childList.length) {
              const childCode = findUniqueCode(item.childList);
              if (childCode) return childCode;
            }
          }
          return null;
        };

        const uniqueCode = to.meta.hasKey ? to.query.key : findUniqueCode(tree);
        if (!uniqueCode) {
          throw new Error('未找到匹配的权限标识');
        }

        // 异步获取按钮权限
        btnAuth = await store.dispatch('updateBtnAuthAsync', uniqueCode);
        if (!btnAuth) {
          throw new Error('未获取到按钮权限');
        }
      }

      // 更新权限缓存
      btnAllAuth[to.path] = { ...(btnAllAuth[to.path] || {}), ...btnAuth };
      store.commit('SET_BTN_AUTH', btnAuth);
      store.commit('SET_ALL_BTN_AUTH', btnAllAuth);

      // 验证通过，放行
      next();
    } catch (error) {
      // console.error('权限校验失败:', error);
      // 如果是报错未登录就去登录页
      if (error.message.includes('未登录')) {
        store.commit('SET_BTN_AUTH', null);
        store.commit('SET_ALL_BTN_AUTH', {});
        clearBtnAuth();
        removeToken();
        next({ path: '/' });
      } else {
        // 其他错误跳转到错误页
        // next({ path: '/errorPage' });
      }
    } finally {
      // 清理加载状态
      NProgress.done();
      if (loadingInstance) {
          loadingInstance.close();
          loadingInstance = null;
      }
    }
  } else {
    // 不需要权限验证的页面直接放行
    // if (to.path === '/') {
    //   store.commit('SET_BTN_AUTH', null);
    //   store.commit('SET_ALL_BTN_AUTH', {});
    //   clearBtnAuth();
    //   removeToken();
    // }
    next();
    NProgress.done();
  }
});

vueRouter.afterEach(() => {
  NProgress.done();
});



// WEBPACK FOOTER //
// ./src/permission.js